import { WifiOff } from 'lucide-react'
import { useOnlineStatus } from '@/hooks/useOfflineSync'

export function OfflineBanner() {
  const isOnline = useOnlineStatus()

  if (isOnline) return null

  return (
    <div className="fixed top-0 inset-x-0 z-[60] bg-amber-500 text-white text-center py-1.5 text-sm font-medium flex items-center justify-center gap-2">
      <WifiOff className="h-3.5 w-3.5" />
      Voce esta offline — dados serao sincronizados quando a conexao voltar
    </div>
  )
}
